// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var API = function API(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5 3.125c.344 0 .625.281.625.625v12.5a.627.627 0 0 1-.625.625h-15a.627.627 0 0 1-.625-.625V3.75c0-.344.281-.625.625-.625zM2.5 1.25A2.5 2.5 0 0 0 0 3.75v12.5c0 1.379 1.121 2.5 2.5 2.5h15c1.379 0 2.5-1.121 2.5-2.5V3.75c0-1.379-1.121-2.5-2.5-2.5zm1.496 4.68a.934.934 0 0 0 .059 1.324L7.05 10l-2.996 2.746A.938.938 0 0 0 5.32 14.13l3.75-3.438a.938.938 0 0 0 0-1.383L5.32 5.872a.934.934 0 0 0-1.324.059m5.692 7.195a.935.935 0 0 0-.938.938c0 .519.418.937.938.937h5.624c.52 0 .938-.418.938-.937a.935.935 0 0 0-.937-.938z"
  }));
};
